import React from 'react'
import PropTypes from 'prop-types'
import { useState } from 'react'
import clsx from 'clsx'
import CheckBox from '../CheckBox/CheckBox'
import AnimateHeight from 'react-animate-height'

const formatFiltersWithIds = filterGroups => {
    return filterGroups?.map((filterG, filterGIndex) => ({
        ...filterG,
        id: filterGIndex,
        filters: filterG?.filters?.map((filter, filterIndex) => ({
            ...filter,
            id: filterIndex,
        })),
    }))
}

const FilterDropDown = ({ filtersGroup = [], text }) => {
    const [filters, setFilters] = useState(formatFiltersWithIds(filtersGroup))
    const [open, setOpen] = useState(false)

    const toggleFilter = (filterGroupId, filterId) => {
        const newFilters = filters?.map(fg => {
            if (fg?.id === filterGroupId) {
                return {
                    ...fg,
                    filters: fg?.filters?.map(f => {
                        if (f?.id === filterId) {
                            return {
                                ...f,
                                checked: !f?.checked,
                            }
                        }
                        return f
                    }),
                }
            }
            return fg
        })
        setFilters([...newFilters])
    }

    const toggleOpen = () => {
        setOpen(!open)
    }

    return (
        <div className="flex flex-row items-center justify-center relative">
            <button
                onClick={toggleOpen}
                className="w-auto px-4 h-12 rounded-xl border border-solid border-grayLines bg-white flex flex-row items-center justify-center"
            >
                <p className="text-textDarkGray text-sm font-normal">{text}</p>
            </button>
            <AnimateHeight
                className="absolute right-0 top-14 z-30 w-max"
                id="locationList-panel"
                duration={150}
                height={open ? 'auto' : 0}
            >
                <div className="w-auto h-auto p-4 border border-grayLines bg-white rounded-xl shadow-lg">
                    {filters?.map((filterGroup, index) => {
                        return (
                            <div
                                key={`${filterGroup?.filterGroupName}-${filterGroup?.id}`}
                                className={clsx(
                                    'w-auto h-auto flex flex-col items-start justify-start',
                                    index !== 0 && 'border-t border-grayLines',
                                )}
                            >
                                <p className="font-bold mb-2 text-sm text-textDarkerGray">
                                    {filterGroup?.filterGroupName}
                                </p>
                                {filterGroup.filters?.map(filter => {
                                    return (
                                        <div key={filter?.id} className="mb-2">
                                            <CheckBox
                                                label={filter?.name}
                                                onChange={() =>
                                                    toggleFilter(
                                                        filterGroup?.id,
                                                        filter?.id,
                                                    )
                                                }
                                                defaultChecked={filter?.checked}
                                                size="small"
                                            />
                                        </div>
                                    )
                                })}
                            </div>
                        )
                    })}
                </div>
            </AnimateHeight>
        </div>
    )
}

FilterDropDown.propTypes = {
    filtersGroup: PropTypes.arrayOf(
        PropTypes.shape({
            filterGroupName: PropTypes.string,
            filters: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string,
                    checked: PropTypes.string,
                }),
            ),
        }),
    ),
    text: PropTypes.string,
}

export default FilterDropDown
